import { Alert, Space, Table } from "antd";
import { FEATURE_FLAG_AUTOMATED_PAYMENTS } from "common/constants";
import useGetBrandDotsApp from "hooks/useGetBrandDotsApp";
import {
    useGetBrandFeatureFlagStatuses,
    useGetFeatureFlags,
} from "hooks/useGetFeatureFlags";
import { columnDefs_featureFlags } from "./feature-flag.columns";
//import { useGetAdminSession } from "hooks/useGetUserSession";

export const FEATURE_FLAG_PERMISSION_WHITELIST =
    process.env.REACT_APP_ENV === "production"
        ? [
              1068741, // James
          ]
        : [];

const FeatureFlags = ({ brandUserId }) => {
    const { data: featureFlagList, isLoading: featureflagListLoading } =
        useGetFeatureFlags();

    const {
        data: brandFeatureFlagStatuses,
        isLoading: brandFeatureFlagStatusesLoading,
    } = useGetBrandFeatureFlagStatuses(brandUserId);

    // Fetched once for the whole table rather than per row: only the automated payments
    // flag cares about it, and every row would otherwise share the same request anyway.
    const {
        data: dotsApp,
        isLoading: dotsAppLoading,
        isError: dotsAppError,
    } = useGetBrandDotsApp(brandUserId);

    const tableData = featureFlagList?.map((flag) => {
        const brandStatus = brandFeatureFlagStatuses?.find(
            (status) => status.featureFlagId === flag.id,
        );

        return {
            ...flag,
            brandStatus: brandStatus?.status,
            // Automated payments is inert without a Dots app — the brand gets the whole
            // Payments UI and every payout fails — so its toggle warns before enabling.
            // Every other flag stands on its own.
            requiresDotsApp: flag.slug === FEATURE_FLAG_AUTOMATED_PAYMENTS,
            hasDotsApp: !!dotsApp,
            dotsAppUnknown: dotsAppLoading || dotsAppError,
        };
    });

    //const userSession = useGetAdminSession();

    const canEdit = true; // Override permissions check
    // FEATURE_FLAG_PERMISSION_WHITELIST?.length > 0
    //     ? FEATURE_FLAG_PERMISSION_WHITELIST.includes(
    //           userSession?.sessionUserId,
    //       )
    //     : true;

    return (
        <Space direction="vertical" style={{ width: "100%" }}>
            {!canEdit && (
                <Alert
                    message="You do not have permissions to make changes on this page."
                    type="warning"
                    showIcon
                />
            )}
            <Table
                bordered
                columns={[...columnDefs_featureFlags]}
                dataSource={tableData || []}
                loading={
                    featureflagListLoading ||
                    brandFeatureFlagStatusesLoading ||
                    dotsAppLoading
                }
                pagination={{
                    position: ["bottomCenter"],
                    hideOnSinglePage: true,
                    pageSize: 1000,
                }}
                rowKey={(record) => record.id}
                size="small"
            />
        </Space>
    );
};

export default FeatureFlags;
